import store from 'store';

import { INITIALIZE_AUTH } from '../containers/App/constants';

const initializeAuth = () => {
  store.dispatch({ type: INITIALIZE_AUTH });
};

export { initializeAuth };
